import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { AdBannerMobile } from "@/components/Ads";
import { Section } from "@/components/UI";
import { FarbweltTeaser } from "@/components/utilsComponents";
import { useRefsContext } from "@/contexts/ref";
import { useFarbwelt } from "@/hooks";
import { useIsNewBuildProject } from "@/shared/hooks";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
export const Sponsor = () => {
    const { isFarbweltActive, teasers } = useFarbwelt();
    const { sponsorRef } = useRefsContext();
    const isPreviewMode = useIsPreviewMode();
    const isProject = useIsNewBuildProject();
    const teaser = Array.isArray(teasers) && // temporary fix while we wait for bff to return an array
        (teasers === null || teasers === void 0 ? void 0 : teasers.find((teaser) => teaser.type === "MobileBanner"));
    return (_jsx(_Fragment, { children: isPreviewMode || (isFarbweltActive && !teaser) || isProject ? null : (_jsx(Section, { ref: sponsorRef, display: {
                "breakpoint.base": "block",
                "breakpoint.lg": "none",
            }, DividerBoxProps: {
                display: {
                    "breakpoint.base": "block",
                    "breakpoint.lg": "none",
                },
            }, unsafeClassname: "HideOnPrint", children: isFarbweltActive ? (_jsx(FarbweltTeaser
            // @ts-ignore
            , { 
                // @ts-ignore
                teaser: teaser, variant: "mobile", av_zone: "middle" })) : (_jsx(AdBannerMobile, {})) })) }));
};
